/* eslint-disable no-useless-computed-key */
import { createContext, useContext, useReducer } from 'react'
import { participantConst } from '../utils/action.constant'

const ParticipantContext = createContext()
export const useParticipantContext = () => useContext(ParticipantContext)

const initialState = {
  participantActiveFromInfo: {
    isActive:false
  },
}

const ParticipantReducer = (state, action) => {
  switch (action.type) {
    case participantConst.SET_PARTICIPANT_ACTIVE:
      return {
        ...state,
        participantActiveFromInfo:{
        ...state.participantActiveFromInfo,
          ['isActive']: true
        }
      };
    default:
      return state
  }
}

export const ParticipantContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ParticipantReducer, initialState)

  return (
    <ParticipantContext.Provider value={{ state, dispatch }}>
      {children}
    </ParticipantContext.Provider>
  )
}
